import React from 'react';

import Skel from '../../components/skel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles.css';

const LabelSubtitle = withStyles({
  root: {
    color: '#8B8B8D',
    textTransform: 'uppercase',
    fontSize: '12px',
  }
})(Typography);

export default function FreightDetails({ query = {} }) {
  const freightName = query?.freight?.name;
  const loading = !freightName;

  return <>
    <div className={styles.sectionTitleWrapper}>
      <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '0px' }}>
        Dados do Transportador
      </Typography>
      <hr style={{ margin: 0, borderColor: '#8B8B8D', borderWidth: '1px' }} />
    </div>

    <Grid
      spacing={24}
      container
      style={{ fontSize: '14px', fontWeight: 'bold', padding: '0rem 5px' }}
    >
      <Grid item sm={6}>
        <div className={styles.gridCell}>
          <LabelSubtitle variant="subtitle2">
            Nome
          </LabelSubtitle>
          <Skel loading={loading}>{freightName || '-'}</Skel>
        </div>
      </Grid>
    </Grid>
  </>;
}
